export default {
  applicationDetail: {
    collapseTitle: {
      baseTitle: '开证申请',
      contractDetail: '合同信息',
      fileTitle: '附件上传',
    },
    btnList: {
      edit: '修改/显示',
      save: '保存',
      submit: '提交审批',
      revoke: '撤回',
      withdraw: '撤销开证',
      upload: '上传附件',
      print: '打印',
      add: '新增',
      remove: '删除',
      copy: '复制',
      ladeOrder: '提单',
      viewLadeOrder: '查看提单',
    },
    goodsTable: {
      indexTitle: '序号',
      contractNo: '合同号',
      externalContractNo: '外部合同号',
      contractDetailNo: '合同行项目',
      productNo: '物料号',
      productDesc: '物料描述',
      purchaseQuantity: '数量',
      issueQuantity: '实际数量',
      businessContractUnitPrice: '单价',
      businessContractTotalAmount: '总金额',
      issueAmount: '本次开证金额',
    },
    msg: {
      goodsMsg: '请填写合同信息',
      detailTip: '请填写必要的开证申请信息',
      updateSusscess: '修改成功！',
      saveSussess: '新增成功！',
      submitSussess: '提交成功！',
      success: '成功！',
      error: '失败！',
      comfirmSusscess: '确认成功！',
    },
  },
  //信用证主表
  tFundCreditLetter: {
    column: {
      businessCompanyCode: '公司编码收证公司编码',
      businessCompanyName: '公司',
      businessDepartmentCode: '业务部门编码收证业务部门编码',
      businessDepartmentName: '部门',
      applyNo: '申请单号',
      applyDate: '申请日期',
      applyUserId: '申请人ID',
      applyUserName: '申请人',
      exchangeType: '汇率类型',
      applyExchangeRate: '开证申请汇率',
      applyExchangeRateDate: '开证申请汇率日期',
      exchangeRate: '汇率',
      exchangeRateDate: '汇率日期',
      currencyCode: '币种',
      currencyName: '币种名称',
      applyClAmount: '开证申请金额',
      applyClStandardAmount: '开证申请本位币金额',
      clAmount: '开证金额',
      clStandardAmount: '开证本位币金额',
      statusFlag: '信用证状态',
      partnerCode: '受益人',
      partnerName: '存的合作伙伴名称收证时，存开证申请人',
      clType: '信用证类别',
      clValidDate: '信用证有效日期',
      importExportNature: '经营性质',
      acceptanceAmount: '已承兑金额',
      shipmentPlace: '起运港',
      destinationPlace: '目的港',
      overShortShippedPercentage: '溢短装比例/%',
      clAttr: '信用证属性',
      paidAmount: '已付款金额',
      latestShipDate: '最迟装期',
      estimatedArrivalDate: '预计到港日',
      estimatedPayDate: '预计付汇日',
      clNature: '信用证性质',
      usanceDaysNumber: '远期天数',
      applyBranchCode: '开证银行',
      applyBranchName: '申请的开证银行名称',
      applyBankAccountNum: '申请的开证银行账户号码',
      payCondition: '付款条件',
      presentationPeriod: '交单期限/天',
      businessNature: '业务性质',
      applyMarginAmount: '银行保证金金额',
      issueCost: '开证费用',
      acceptanceCost: '承兑费用',
      accountStatus: '入账状态',
      accountDate: '入账日期',
      voucherCode: '凭证编号',
      summary: '摘要',
      clMarginRate: '开证保证金比例',
      clIssueCostRate: '开证费用比例',
      clAcceptanceCostRate: '承兑费用比例',

      clCode: '信用证号',
      issueDate: '开证日期',
      issueType: '开证类型',
      marginRate: '银行保证金比率%',
      marginAmount: '银行保证金金额',
      marginCurrencyCode: '保证金币种',
      marginCurrencyName: '保证币种名称',
      marginPayDate: '保证金支付日期',
      marginExchangeType: '保证金汇率类型(字典)',
      marginExchangeRate: '保证金汇率',
      marginExchangeRateDate: '保证金汇率日期',
      marginStandardAmount: '银行保证金本币金额',
      marginPayAccount: '保证金转出银行账户',
      marginReceiveAccount: '保证金转入银行账户',
      branchCode: '开证银行',
      branchName: '银行名称收证时开证银行名称',
      payBranchCode: '付款行代码 收证时付款行银行代码',
      payBranchName: '付款银行名称 收证时付款银行名称',
      notifyingBranchCode: '通知行代码 收证时通知行银行代码',
      notifyingBranchName: '通知行名称 收证时通知行银行名称',
      negotiationBranchCode: '议付行代码 收证时议付行代码',
      negotiationBranchName: '议付行名称 收证时议付行名称',
      receivingDate: '收证时收证日期',
      cashflowTransactionCode: '现金流量事务代码',
      isIndependent: '独立开证',
      isForeignParent: '外商母证开证',
      isRefundMargin: '已退回保证金',
      isAccpetComplete: '是否完全承兑',
      acceptCompleteDate: '完全承兑日期',
      isPayComplete: '是否完全付款',
      registerNo: '收款单号',
      paidDate: '实际收款日期',
      receiveBankName: '收款银行名称',
    },
    placeholder: {
      businessCompanyCode: '请输入公司编码收证公司编码',
      businessCompanyName: '请输入公司名收证公司名称',
      businessDepartmentCode: '请输入业务部门编码收证业务部门编码',
      businessDepartmentName: '请输入业务部门名收证业务部门名',
      applyNo: '请输入申请单号',
      applyDate: '请选择申请日期',
      applyUserId: '请输入申请人ID',
      applyUserName: '请输入申请人名称',
      exchangeType: '请选择请输入汇率类型(字典)',
      applyExchangeRate: '请输入开证申请汇率',
      applyExchangeRateDate: '请输入开证申请汇率日期',
      exchangeRate: '请输入汇率',
      exchangeRateDate: '请选择汇率日期',
      currencyCode: '请输入币种编码',
      currencyName: '请输入币种名称',
      applyClAmount: '请输入申请的开证金额',
      clAmount: '请输入申请的开证金额',
      applyClStandardAmount: '请输入申请的开证本位币金额',
      statusFlag: '请输入信用证状态',
      // partnerCode:'请输入存的合作伙伴编码收证时，存开证申请人',
      // partnerName:'请输入存的合作伙伴名称收证时，存开证申请人',
      clType: '请选择信用证类别收证同',
      clValidDate: '请选择信用证有效日期',
      importExportNature: '请输入经营性质',
      acceptanceAmount: '请输入已承兑金额 开证收证均有',
      shipmentPlace: '请输入起运港',
      destinationPlace: '请输入目的港',
      overShortShippedPercentage: '请输入溢短装比例收证时也有',
      clAttr: '请输入信用证属性 开证收证都有',
      paidAmount: '请输入已付款金额 开证收证时存的是已收款金额',
      latestShipDate: '请选择最迟装期 开证收证',
      estimatedArrivalDate: '请选择预计到港日',
      estimatedPayDate: '请选择预计付汇日',
      clNature: '请输入信用证性质',
      usanceDaysNumber: '请输入远期天数 开证收证',
      applyBranchCode: '请输入申请的开证银行代码',
      applyBranchName: '请输入申请的开证银行名称',
      applyBankAccountNum: '请输入申请的开证银行账户号码',
      payCondition: '请输入付款条件 开证收证',
      presentationPeriod: '请输入交单期 手工输入对应的天数',
      businessNature: '请输入业务性质',
      applyMarginAmount: '请输入申请的银行保证金金额',
      issueCost: '请输入开证费用',
      acceptanceCost: '请输入承兑费用',
      accountStatus: '请选择入账状态 0-未入账,其他状态待确认',
      accountDate: '请选择入账日期',
      voucherCode: '请输入凭证编号',
      summary: '请输入摘要,以上是申请信息',
      clCode: '请输入以下是开证信息 信用证号收证同',
      issueDate: '请选择开证日期',
      issueType: '请选择开证类型',
      marginRate: '请输入银行保证金比率',
      marginAmount: '请输入银行保证金金额',
      marginCurrencyCode: '请输入保证金币种编码',
      marginCurrencyName: '请输入保证币种名称',
      marginPayDate: '请选择保证金支付日期',
      marginExchangeType: '请选择保证金汇率类型(字典)',
      marginExchangeRate: '请输入保证金汇率',
      marginExchangeRateDate: '请选择保证金汇率日期',
      marginStandardAmount: '请输入银行保证金本币金额',
      marginPayAccount: '请输入保证金转出银行账户',
      marginReceiveAccount: '请输入保证金转入银行账户',
      branchCode: '请输入开证银行',
      branchName: '请输入银行名称收证时开证银行名称',
      payBranchCode: '请输入付款行代码 收证时付款行银行代码',
      payBranchName: '请输入付款银行名称 收证时付款银行名称',
      notifyingBranchCode: '请输入通知行代码 收证时通知行银行代码',
      notifyingBranchName: '请输入通知行名称 收证时通知行银行名称',
      negotiationBranchCode: '请输入议付行代码 收证时议付行代码',
      negotiationBranchName: '请输入议付行名称 收证时议付行名称',
      receivingDate: '请选择收证时收证日期',
      cashflowTransactionCode: '请输入现金流量事务代码',
      isIndependent: '请输入是否独立开证1独立 0非独立',
      isForeignParent: '请输入外商母证开证1是 0 否',
      isRefundMargin: '请输入已退回保证金1已退 0未退',
      isAccpetComplete: '请输入是否完全承兑1是 0否',
      acceptCompleteDate: '请选择完全承兑日期',
      isPayComplete: '请输入是否完全付款1是 0 否',
      partnerCode: '请输入收证时，客户编码',
      partnerName: '请输入收证时，客户名称',
      registerNo: '请输入收款单号',
      paidDate: '请选择实际收款日期',
      receiveBankName: '请输入收款银行名称',
    },
  },
  //信用证合同表
  tFundCreditLetterContract: {
    column: {
      tenantCode: '租户编码',
      companyCode: '公司编码',
      departmentCode: '部门编码',
      companyName: '公司名',
      departmentName: '部门名',
      gmtCreate: '记录创建时间',
      gmtModified: '记录更新时间',
      lastModifiedBy: '记录最后更新人',
      isDeleted: '是否删除(1删除,0未删除)',
      sortNo: '序号',
      version: '版本',
      clId: '信用证ID',
      contractNo: '合同号',
      externalContractNo: '外部合同号',
      contractDetailNo: '合同行项目',
      productNo: '物料号',
      productDesc: '物料描述',
      purchaseQuantity: '数量',
      issueQuantity: '实际数量',
      businessContractUnitPrice: '单价',
      businessContractTotalAmount: '总金额',
      issueAmount: '本次开证金额',

      clCode: '信用证号',
      issueDate: '开证日期',
      issueType: '开证类型',
      marginRate: '银行保证金比率%',
      marginAmount: '银行保证金金额',
      marginCurrencyCode: '保证金币种编码',
      marginCurrencyName: '保证币种名称',
      marginPayDate: '保证金支付日期',
      marginExchangeType: '保证金汇率类型(字典)',
      marginExchangeRate: '保证金汇率',
      marginExchangeRateDate: '保证金汇率日期',
      marginStandardAmount: '银行保证金本币金额',
      marginPayAccount: '保证金转出银行账户',
      marginReceiveAccount: '保证金转入银行账户',
      branchCode: '开证银行',
      branchName: '银行名称收证时开证银行名称',
      payBranchCode: '付款行代码 收证时付款行银行代码',
      payBranchName: '付款银行名称 收证时付款银行名称',
      notifyingBranchCode: '通知行代码 收证时通知行银行代码',
      notifyingBranchName: '通知行名称 收证时通知行银行名称',
      negotiationBranchCode: '议付行代码 收证时议付行代码',
      negotiationBranchName: '议付行名称 收证时议付行名称',
      receivingDate: '收证时收证日期',
      cashflowTransactionCode: '现金流量事务代码',
      isIndependent: '是否独立开证1独立 0非独立',
      isForeignParent: '外商母证开证1是 0 否',
      isRefundMargin: '已退回保证金1已退 0未退',
      isAccpetComplete: '是否完全承兑1是 0否',
      acceptCompleteDate: '完全承兑日期',
      isPayComplete: '是否完全付款1是 0 否',
    },
    placeholder: {
      tenantCode: '请输入租户编码',
      companyCode: '请输入公司编码',
      departmentCode: '请输入部门编码',
      companyName: '请输入公司名',
      departmentName: '请输入部门名',
      gmtCreate: '请选择记录创建时间',
      gmtModified: '请选择记录更新时间',
      lastModifiedBy: '请输入记录最后更新人',
      isDeleted: '请输入是否删除(1删除,0未删除)',
      sortNo: '请输入序号',
      version: '请输入版本',
      clId: '请输入信用证ID',
      contractNo: '请输入合同号',
      externalContractNo: '请输入外部合同号',
      contractDetailNo: '请输入合同行项目',
      productNo: '请输入物料号',
      productDesc: '请输入物料描述',
      purchaseQuantity: '请输入数量',
      issueQuantity: '请输入实际数量',
      businessContractUnitPrice: '请输入单价',
      businessContractTotalAmount: '请输入总金额',
      issueAmount: '请输入本次开证金额',

      clCode: '请输入信用证号',
      issueDate: '请选择开证日期',
      issueType: '请选择开证类型',
      marginRate: '请输入银行保证金比率',
      marginAmount: '请输入银行保证金金额',
      marginCurrencyCode: '请输入保证金币种编码',
      marginCurrencyName: '请输入保证币种名称',
      marginPayDate: '请选择保证金支付日期',
      marginExchangeType: '请选择保证金汇率类型(字典)',
      marginExchangeRate: '请输入保证金汇率',
      marginExchangeRateDate: '请选择保证金汇率日期',
      marginStandardAmount: '请输入银行保证金本币金额',
      marginPayAccount: '请输入保证金转出银行账户',
      marginReceiveAccount: '请输入保证金转入银行账户',
      branchCode: '开证银行',
      branchName: '请输入银行名称收证时开证银行名称',
      payBranchCode: '请输入付款行代码 收证时付款行银行代码',
      payBranchName: '请输入付款银行名称 收证时付款银行名称',
      notifyingBranchCode: '请输入通知行代码 收证时通知行银行代码',
      notifyingBranchName: '请输入通知行名称 收证时通知行银行名称',
      negotiationBranchCode: '请输入议付行代码 收证时议付行代码',
      negotiationBranchName: '请输入议付行名称 收证时议付行名称',
      receivingDate: '请选择收证时收证日期',
      cashflowTransactionCode: '请输入现金流量事务代码',
      isIndependent: '请输入是否独立开证1独立 0非独立',
      isForeignParent: '请输入外商母证开证1是 0 否',
      isRefundMargin: '请输入已退回保证金1已退 0未退',
      isAccpetComplete: '请输入是否完全承兑1是 0否',
      acceptCompleteDate: '请选择完全承兑日期',
      isPayComplete: '请输入是否完全付款1是 0 否',
    },
  },
  //信用证承兑表
  tFundCreditLetterAcceptance: {
    column: {
      tenantCode: '租户编码',
      companyCode: '公司编码',
      departmentCode: '部门编码',
      companyName: '公司名',
      departmentName: '部门名',
      gmtCreate: '记录创建时间',
      gmtModified: '记录更新时间',
      lastModifiedBy: '记录最后更新人',
      isDeleted: '是否删除(1删除,0未删除)',
      sortNo: '序号',
      version: '版本',
      clCode: '信用证号',
      acceptDate: '承兑日期',
      acceptAmount: '承兑金额',
      planPayDate: '应付汇日期',
      planPayExchangeRate: '应付汇汇率',
      planPayAmount: '计划收款金额',
      contractNo: '合同号',
      externalContractNo: '外部合同号',
      contractDetailNo: '合同行项目',
      remark: '备注',
      productNo: '商品编码',
      productDesc: '商品描述',
      isArrivalDifference: '有不符点',
      isRefusePayment: '拒付',
      refusePaymentDueDate: '拒付到期日',
      isPaid: '已付款',
      paymentNo: '付款单号',
      statusFlag: '承兑状态',
      paidAmount: '已付款金额',
      unpaidAmount: '未付款金额',
      delayPaymentType: '是否押汇',
      isLockExchangeRate: '是否锁汇',
      partnerCode: '收证时，客户编码',
      partnerName: '客户',
      registerNo: '收款单号',
      paidDate: '实际收款日期',
      receiveBankName: '收款银行名称',
    },
    placeholder: {
      tenantCode: '请输入租户编码',
      companyCode: '请输入公司编码',
      departmentCode: '请输入部门编码',
      companyName: '请输入公司名',
      departmentName: '请输入部门名',
      gmtCreate: '请选择记录创建时间',
      gmtModified: '请选择记录更新时间',
      lastModifiedBy: '请输入记录最后更新人',
      isDeleted: '请输入是否删除(1删除,0未删除)',
      sortNo: '请输入序号',
      version: '请输入版本',
      clCode: '请输入信用证号',
      acceptDate: '请选择承兑日期',
      acceptAmount: '请输入承兑金额',
      planPayDate: '请选择应付汇日期计划收款日期',
      planPayExchangeRate: '请输入应付汇汇率',
      planPayAmount: '请输入计划收款金额',
      contractNo: '请输入采购合同编码收款时销售合同编码',
      externalContractNo: '请输入外部合同号',
      contractDetailNo: '请输入采购合同行项目编号收款时销售合同行项目编号',
      remark: '请输入备注',
      productNo: '请输入商品编码',
      productDesc: '请输入商品描述',
      isArrivalDifference: '请输入有不浮点 1-有,0没有',
      isRefusePayment: '请输入1-拒付 0-未拒付',
      refusePaymentDueDate: '请选择拒付到期日',
      isPaid: '请输入1,已付 0-未付',
      statusFlag: '请输入承兑状态',
      paidAmount: '请输入已付款金额实际收款金额',
      unpaidAmount: '请输入未付款金额',
      delayPaymentType: '请选择押汇信息',
      isLockExchangeRate: '请输入是否锁汇1 是,0 否',
      partnerCode: '请输入收证时，客户编码',
      partnerName: '请输入收证时，客户名称',
      registerNo: '请输入收款单号',
      paidDate: '请选择实际收款日期',
      receiveBankName: '请输入收款银行名称',
    },
  },
  tFundCreditLetterLockExchangeRate: {
    column: {
      tenantCode: '租户编码',
      companyCode: '公司编码',
      departmentCode: '部门编码',
      companyName: '公司名',
      departmentName: '部门名',
      gmtCreate: '记录创建时间',
      gmtModified: '记录更新时间',
      lastModifiedBy: '记录最后更新人',
      isDeleted: '是否删除(1删除,0未删除)',
      sortNo: '序号',
      version: '版本',
      acceptanceId: '承兑行项目id',
      lockAmount: '锁汇金额',
      externalLockExchangeRate: '外部锁汇价',
      internalLockExchangeRate: '内部锁汇价',
      branchCode: '锁汇银行代码',
      branchName: '锁汇银行名称',
      bankAccountNum: '锁汇银行账户号码',
      bankAccountName: '锁汇银行账户名',
      lockDueDate: '锁汇到期日',
    },
    placeholder: {
      tenantCode: '请输入租户编码',
      companyCode: '请输入公司编码',
      departmentCode: '请输入部门编码',
      companyName: '请输入公司名',
      departmentName: '请输入部门名',
      gmtCreate: '请选择记录创建时间',
      gmtModified: '请选择记录更新时间',
      lastModifiedBy: '请输入记录最后更新人',
      isDeleted: '请输入是否删除(1删除,0未删除)',
      sortNo: '请输入序号',
      version: '请输入版本',
      acceptanceId: '请输入承兑行项目id',
      lockAmount: '请输入锁汇金额',
      externalLockExchangeRate: '请输入外部锁汇价',
      internalLockExchangeRate: '请输入内部锁汇价',
      branchCode: '请输入锁汇银行代码',
      branchName: '请输入锁汇银行名称',
      bankAccountNum: '请输入锁汇银行账户号码',
      bankAccountName: '请输入锁汇银行账户名',
      lockDueDate: '请选择锁汇到期日',
    },
  },
  tFundCreditLetterDelayPayment: {
    column: {
      tenantCode: '租户编码',
      companyCode: '公司编码',
      departmentCode: '部门编码',
      companyName: '公司名',
      departmentName: '部门名',
      gmtCreate: '记录创建时间',
      gmtModified: '记录更新时间',
      lastModifiedBy: '记录最后更新人',
      isDeleted: '是否删除(1删除,0未删除)',
      sortNo: '序号',
      version: '版本',
      acceptanceId: '承兑行项目id',
      delayAmount: '押汇金额',
      delayExchangeRate: '押汇利率(%)',
      delayCost: '押汇费用',
      delayDate: '押汇日期',
      delayPaymentDate: '押汇到期日',
      branchCode: '押汇银行代码',
      branchName: '押汇银行名称',
      bankAccountNum: '押汇银行账户号码',
      businessDepartmentCode: '部门',
      businessDepartmentName: '业务部门名收证业务部门名',
      isLockExchangeRate: '是否锁汇',
    },
    placeholder: {
      tenantCode: '请输入租户编码',
      companyCode: '请输入公司编码',
      departmentCode: '请输入部门编码',
      companyName: '请输入公司名',
      departmentName: '请输入部门名',
      gmtCreate: '请选择记录创建时间',
      gmtModified: '请选择记录更新时间',
      lastModifiedBy: '请输入记录最后更新人',
      isDeleted: '请输入是否删除(1删除,0未删除)',
      sortNo: '请输入序号',
      version: '请输入版本',
      acceptanceId: '请输入承兑行项目id',
      delayAmount: '请输入押汇金额',
      delayExchangeRate: '请输入押汇利率',
      delayCost: '请输入押汇费用',
      delayDate: '请选择押汇日期',
      delayPaymentDate: '请选择押汇到期日',
      branchCode: '请输入押汇银行代码',
      branchName: '请输入押汇银行名称',
      bankAccountNum: '请输入押汇银行账户号码',
      businessDepartmentCode: '部门',
      businessDepartmentName: '请输入业务部门名收证业务部门名',
      isLockExchangeRate: '是否锁汇',
    },
  },
};
